<script>
export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    }
  },
  computed: {
    height() {
      return this.$vuetify.breakpoint.smAndDown ? '56px' : '64px'
    }
  }
}
</script>
<template>
  <v-toolbar :color="color" dark :max-height="height" elevation="0">
    <v-spacer />
    <v-toolbar-title class="text-center resetWhitespace">
      <h2 class="headline text--primary-2">
        <slot class="wordBreak"></slot>
      </h2>
    </v-toolbar-title>
    <v-spacer />
  </v-toolbar>
</template>
<style lang="scss" scoped>
.resetWhitespace {
  white-space: unset;
}
</style>
